import { i18n } from 'core/localization';

export default [
	{
		text: i18n('Critical'),
		color: 1,
		value: 'CRITICAL',
	},
	{
		text: i18n('Major'),
		color: 2,
		value: 'MAJOR',
	},
	{
		text: i18n('Minor'),
		color: 3,
		value: 'MINOR',
	},
	{
		text: i18n('None'),
		color: 5,
		value: 'NONE',
	},
];
